import { AssetBookingConfigBase } from './asset-booking-config.base';

export const AssetBookingConfig = {
  ...AssetBookingConfigBase,
  BILLING_MODULE: {
    ...AssetBookingConfigBase.BILLING_MODULE,
    ENABLED: false,
    ENABLED_FULL_ADDRESS_FORM: false,
  }
};
